import styled from "styled-components";

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownButton = styled.button`
  display: flex;
  background-color: transparent;
  font-family: Mulish, sans-serif;
  color: #fff;
  padding: 10px;
  border: none;
  cursor: pointer;
  font-size: 20px;
  letter-spacing: 1.2px;
  &:hover {
    color: rgb(182, 182, 182);
  }
`;

export const DropdownContent = styled.div<{ isOpen: boolean }>`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  position: absolute;
  background-color: #f9f9f9;
  border-radius: 8px;
  min-width: 160px;
  box-shadow: 4px 0px 16px 0px #0000001f;
  z-index: 1;

  a {
    color: #0d51f1;
    font-family: Mulish, sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0px;
    text-decoration: none;
    display: block;
    padding: 11px 22px;

    &:hover {
      background-color: #ddd;
      border-radius: 8px;
      color: #0d51f1;
    }
  }
`;
